import type { ProductPageContent } from '@/content/products';
import { accentText } from '@/lib/product-accents';
import { cn } from '@/lib/utils';

export function ProductProblem({ product }: { product: ProductPageContent }) {
  return (
    <section
      aria-labelledby={`${product.id}-problem-heading`}
      className="px-4 py-14 sm:px-6 sm:py-16 lg:px-8"
    >
      <div className="border-border/60 bg-card/40 mx-auto w-full max-w-7xl rounded-2xl border px-6 py-10 backdrop-blur-sm sm:px-10 sm:py-12">
        <p className={cn('mb-3 text-xs font-medium tracking-[0.2em] uppercase', accentText[product.accent])}>
          Why this exists
        </p>
        <h2
          id={`${product.id}-problem-heading`}
          className="font-display text-foreground text-2xl font-semibold tracking-tight sm:text-3xl"
        >
          {product.problemHeading}
        </h2>
        <div className="mt-6 max-w-3xl space-y-4">
          {product.problemBody.map((paragraph, index) => (
            <p
              key={`${product.id}-problem-${index}`}
              className="text-muted-foreground text-base leading-relaxed sm:text-lg"
            >
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
